<template lang="pug">
v-container(my-4 pa-0 fluid)
  v-layout(text-xs-left='', wrap='')
    v-flex(xs10 offset-xs1)
      h1.title-all 公民最大？讓投票權發揮更大效益
      br
    v-layout.my-2(v-for="(issue,index) in publicIssue" :key="index" row :data-aos="index%2===0?'fade-left':'fade-right'" data-aos-delay="200" data-aos-duration="1000")
      v-flex.hidden-xs-only(v-if="index==3" sm1 offset-sm1)
        v-img.issue-image-left(:src="issue.image" contain)
      v-flex.public-issue(xs10 offset-xs1 sm8 :class="{'offset-sm1': index%2===0,'offset-sm3': index%2===1&&index!==3, 'offset-sm1': index===3}")
        v-expansion-panel.rounded-card()
          v-expansion-panel-content()
            template(v-slot:actions='')
              v-icon(color='black' v-show="issue.content") fa-chevron-down
            template(v-slot:header='')
              h3.issue-title {{issue.title}}
              br
              .content-all(v-html="issue.preview")
              //- i.fas.fa-chevron-down
            v-card
              v-card-text.content-all(v-if="issue.content" v-html="issue.content")
      v-flex.hidden-xs-only(v-if="index==0||index==4" sm1 offset-sm1)
        v-img.issue-image-right(:src="issue.image" contain)

</template>

<script>
export default {
  data: () => ({
    publicIssue: [
      {
        title: "言論自由",
        preview:
          "聯合國人權事務委員會認為，言論、集會和結社自由必須受到充分保護，支持公民得以透過與其代表公開辯論和對話或透過他們自我組織的能力來施加影響而參與政事與公共事務，是有效行使投票權的重要條件。",
        content:
          "保證公民、候選人和當選代表之間就公共和政治問題自由交流資訊和交換意見，對於有效且有意義地參與政事與投票的權利是至關重要的。這意味著新聞或其他媒體的自由，可以對公共問題發表意見，而不受新聞檢查或限制，和發表公眾意見。",
        image: require("@/assets/radio.png")
      },
      {
        title: "和平集會與自由結社",
        preview:
          "個人或透過政黨和其他組織從事政治活動的自由、辯論公共事務的自由、舉行和平示威和集會的自由、以及包成立或加入涉及政治和公共事務的組織和協會等各種結社自由的權利，都是保障參與政事與投票的權利能夠有效且有意義的關鍵要素。",
        content: ""
      },
      {
        title: "台灣青少年的現況",
        preview:
          "2017年我國首次兒童權利公約國家報告國際審查後，委員指出「未滿20歲的兒童及年輕人無法成立自己的團體，只能在父母或監護人同意下加入既定團體」這種情況不符合兒童及少年的結社自由，亦不尊重兒童及少年逐漸發展的能力。",
        content:
          "建議政府採取必要的立法及其他措施，確保兒童依據其年齡、成熟度及逐漸發展的能力，能夠不受任何歧視、完全享有集會結社及和平集會自由的權利，包括和平抗議的權利。內政部擬廢除《人民團體法》改立《社會團體法》，截至2019年3月《社會團體法》（草案）已完成初審及黨團協商，草案條文中原取消發起人的年齡規定，另有多條涉及保障限制行為能力人的結社權利，可參見黨團協商結論版本。"
      },
      {
        title: "保障學生行使投票權",
        preview: `許多擁有公民投票權與選舉權的公民，同時是學生身份，學校課程的安排將可能嚴重影響其投票行為。過去也曾發生過大學期末考接近與大選日期有衝突，增加學生返鄉投票成本與嚴重影響投票意願。此外，搜尋過去公告許多學校停課的理由，也都是因為學校被借作選舉投開票所使用，並非為保障學生行使選舉等投票權利。`,
        content: `
              民間團體持續從各管道呼籲教育部、國民及學前教育署、直轄市政府教育局對此應採取有效的立法及行政措施，禁止大專院校及高級中等學校在選舉及公民投票日，安排任何學習與非學習節數之時間及活動，並提出相關懲處措施與適性輔導及教育處置，確保盡可能地降低學生行使公民權利的門檻。<br><br>
              教育部國民及學前教育署107年10月31日函示全國各高級中等學校：凡符合公民投票法第7條規定年滿18歲之國民（包括部分高級中等學校學生），均享有公民投票權，各高級中等學校應確實遵守不得影響學生行使公民投票權<a href="http://www.chsh.chc.edu.tw/ezfiles/0/1000/attach/71/pta_15167_6479417_75829.pdf" target="_blank">（臺教國署高字第1070133992號）</a>，公文重點如下：<br><br>
              <text">一、高級中等學校不得於例假日實施學生課業輔導</text><br><br>
              「高級中等學校課業輔導實施要點」第5點規定略以:「學校於學期中辦理之課業輔導，應安排於每日正式課程之後，每週不得逾5日，且不得於國定假日及例假日實施。」<br><br>
              <text">二、高級中等學校不得於公民投票日舉辦活動，避免影響學生行使公民投票權</text><br><br>
              <br><br>
              <text">學校還是排了課程、輔導，讓我不能投票怎麼辦？</text><br><br>
              <ul>
                <li>大專院校學生請向 <a href="http://bit.ly/tellEDU" target="_blank">教育部民意信箱</a> 申訴</li>
                <li>高級中等學校學生請向 <a href="https://www.k12ea.gov.tw/Tw/Mail/MailExplain" target="_blank">國教署長信箱</a> 申訴</li>
                <li>直轄市高級中等學校學生，除國教署外，可再撥打1999轉直轄市政府教育局申訴</li>
              </ul>
              `,
        image: require("@/assets/backpack.png")
      },
      {
        title: "投票日，就是勞工的放假日！",
        preview: `勞動部107年11月8日公告指定「總統副總統選舉罷免投票日」、「公職人員選舉罷免投票日」及「公民投票日」為《勞動基準法》第37條第1項所定應放假之日，並發布新解釋令<a href="https://www.mol.gov.tw/media/5759816/107%E5%B9%B411%E6%9C%888%E6%97%A5%E5%8B%9E%E5%8B%95%E6%A2%9D2%E5%AD%97%E7%AC%AC1070131393%E8%99%9F%E8%A7%A3%E9%87%8B%E4%BB%A4.pdf" target="_blank">（勞動條2字第1070131393號）</a>，解釋具有投票權之勞工於出勤工資的給付規定，供勞雇雙方依公告辦理時有所依循，重點如下：`,
        content: `
              <ul>
                <li>年滿18歲，有公民投票權、選舉權、罷免權者要注意。</li>
                <li>投票日當天為工作日的勞工，應放假一日，工資照給。</li>
                <li>雇主不可有妨礙勞工投票的行為，包括該放假日不得與其他工作日對調實施。</li>
                <li>在不妨礙勞工投票的前提下，雇主若徵得勞工同意，勞工可於該日出勤，但雇主必須提供雙倍工資。</li>
                <li>遇到老闆不給假或給薪？<br>
                  一.可打1955勞工申訴諮詢專線<br>
                  二.向當地縣市政府勞工局申訴<br>
                  三.勞動部提醒，可處新臺幣2萬元以上，最高100萬元之罰鍰，並應補給工資。
                </li>
              </ul>
              `,
        image: require("@/assets/badge.png")
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
.issue-title{
  font-size: 1.5em;
}

.public-issue {
  margin-top: 10px;
}

.issue-image-right{
  transform: translate3d(0,-50%,0) rotate(15deg);
  top: 50%;
}

.issue-image-left{
  transform: translate3d(0,-50%,0) rotate(-15deg);
  top: 50%;
}

.rounded-card{
  border-radius: 10px;
  > li{
    border-radius: 15px;
    i{
      margin-top: 15px;
    }
  }
}

</style>
